// Leaf module for auth state primitives consumed by both auth.ts and other api
// modules. Kept separate from auth.ts (which imports current-user/api and
// auth-sso) so the @tanstack-enabled refs and the LogoutReason enum can be
// imported without forming an import cycle through fetchClient.

import { MFAPreference } from '@@/packages/shared/types/models/user';

export const isAuthenticatedByRLRef = ref(false);

// True when the active cookie session was established via SSO/OAuth (server
// truth from GET /auth/session). supportsLocalCredentials() and the MFA gate
// read this instead of the drift-prone localStorage authMode flag (FEDX-159).
export const isSsoSessionRef = ref(false);

// True while an org switch is reloading the app. fetchClient reads it to skip the
// logout it would otherwise trigger on the rotated session's in-flight 401s, and
// it drives the full-screen loading screen.
export const isSwitchingOrg = ref(false);

// True once a soft reload has happened this page lifetime. The app shell only
// remounts via a soft reload, so this distinguishes a post-switch remount (keep
// the "Loading organisation" screen up while the shell refetches) from the
// first-login/hard-refresh bootstrap (no loading screen). Never reset.
export const hasSoftReloaded = ref(false);

export enum LogoutReason {
  AccountLocked = 'accountLocked',
  SsoEnforced = 'ssoEnforced',
  SessionExpired = 'sessionExpired',
  NetworkError = 'networkError',
}

export function isEnrolledMfaFactor(pref: MFAPreference | null): boolean {
  return pref === MFAPreference.SMS || pref === MFAPreference.TOTP;
}
